import hey from "@lib/hey";
import gsap from "@lib/gsap";
import { Scroll } from "@lib/scroll";

const centerElement = (element: HTMLElement) => {
  const elRect = element.getBoundingClientRect();

  const w = document.documentElement.clientWidth;
  const h = document.documentElement.clientHeight;
  const x = (w - elRect.width) / 2 - elRect.left;
  const y = (h - elRect.height) / 2 - elRect.top;

  element.style.transform = `translate(${x}px, ${y}px)`;
};

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const background = element.querySelector(".c-preloader_bg");
  const logo = element.querySelector(".c-preloader_logo");
  const navDot = document.querySelector("[data-nav-dot]");
  const pageWrap = document.getElementById("page-wrap");

  Scroll.stop();

  gsap.set(pageWrap, {
    opacity: 0,
  });

  gsap.set(background, {
    opacity: 0,
  });

  gsap.set(navDot, {
    visibility: "visible",
    opacity: 0,
  });

  centerElement(navDot as HTMLElement);

  const tl = gsap.timeline({
    onComplete: () => {
      document.body.dataset.preloaded = "true";
      element.remove();
    },
  });

  tl.to(logo, {
    y: 0,
    duration: 0.6,
    ease: "smooth",
  })
    .to(logo, {
      scale: 0.5,
      delay: 0.6,
      duration: 0.6,
      ease: "accelerate",

      onComplete: () => {
        gsap.set(logo, {
          visibility: "hidden",
        });

        gsap.set(navDot, {
          opacity: 1,
        });

        hey.PRELOADER_COMPLETE = true;
        Scroll.start();
      },
    })
    .to(navDot, {
      duration: 0.7,
      delay: 0.1,
      x: 0,
      y: 0,
      ease: "smooth",
    })
    .to(
      pageWrap,
      {
        opacity: 1,
        duration: 1.2,
        ease: "none",
      },
      "<"
    );
}
